import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../../main/main.styles';
import { SummaryTableCell } from '../analytics-step-three.styles';

export const AnalyticsSummaryTableColumnStyle = css`
  ${MainStyles}

  :host {
    contain: inherit;
  }

  :host > div {
    ${SummaryTableCell}
  }

  :host > div:nth-child(even) {
    border-top: 1px solid #373e45;
    background-color: #24272b;
  }

  :host > div:nth-child(odd) {
    border-top: 1px solid #373e45;
    background-color: #1d2024;
  }

  :host > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 16px 4px 12px;
    border: 1px solid #2e3339;
    border-bottom: none;
    border-right: none;
    background-color: #1d2024;
    box-sizing: border-box;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-align: left;
    line-height: 28px;
    flex-direction: row;
    position: sticky;
    z-index: 0;
    top: 0;
  }

  :host > div:last-child {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 16px 4px 12px;
    border: 1px solid #2e3339;
    border-right: none;
    background-color: #24272b;
    box-sizing: border-box;
    line-height: 28px;
    flex-direction: row;
  }

  .favorite-icon {
    background: transparent;
  }

  .first-footer {
    border-bottom-left-radius: 6px;
    border-left: 1px solid rgb(55, 62, 69) !important;
  }

  .last-header ~ div {
    border-right: 1px solid #373e45 !important;
  }

  .first-header {
    border-top-left-radius: 6px;
    border-left: 1px solid rgb(55, 62, 69) !important;
  }

  .last-footer {
    border-bottom-right-radius: 6px;
  }

  .last-header {
    border-top-right-radius: 6px;
    border-right: 1px solid #373e45 !important;
  }

  .market-depth-btn > svg {
    width: 18px;
    height: 12px;
  }

  .market-depth-btn::part(content) {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .market-depth-btn::part(control) {
    padding: 5px;
  }
`;
